import React, { Component } from "react";
import axios from "axios";
import { Table, Button, Modal, Form, Row, Col } from "react-bootstrap";
import CartContext from "./CartContext";

export default class EmployeeRequests extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      requests: [],
      employees: [],
      showModal: false,
      form: {
        id: "",
        employeeId: "",
        storeId: "",
        date: new Date().toISOString().split("T")[0],
        description: "",
        status: 0,
      },
      isEdit: false,
      filters: {
        employeeId: "",
        status: "",
        dateFilter: "today",
        customFrom: "",
        customTo: "",
      },
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.fetchEmployees();
    this.applyFilters();
  }

  fetchEmployees = () => {
    const storeId = this.context.storeId;
    axios
      .get(`${process.env.REACT_APP_API}Employee/GetEmployees/${storeId}`)
      .then((res) => this.setState({ employees: res.data }))
      .catch(() => this.setState({ error: "Failed to load employees." }));
  };

  handleShowModal = (request = null) => {
    if (request) {
      this.setState({ form: request, showModal: true, isEdit: true });
    } else {
      this.setState({
        form: {
          id: "",
          employeeId: "",
          storeId: this.context.storeId,
          date: new Date().toISOString().split("T")[0],
          description: "",
          status: 0,
        },
        showModal: true,
        isEdit: false,
      });
    }
  };

  handleCloseModal = () => this.setState({ showModal: false });

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ form: { ...this.state.form, [name]: value } });
  };

  handleFilterChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      { filters: { ...this.state.filters, [name]: value } },
      () => this.applyFilters() // Auto apply after every change
    );
  };

  applyFilters = () => {
    const { filters } = this.state;
    const storeId = this.context.storeId;

    let url = `${process.env.REACT_APP_API}EmployeeRequests?storeId=${storeId}`;

    if (filters.employeeId) url += `&employeeId=${filters.employeeId}`;
    if (filters.status !== "") url += `&status=${filters.status}`;

    // Calculate date ranges
    let from = "",
      to = "";
    const today = new Date();

    switch (filters.dateFilter) {
      case "today":
        from = new Date(today.setHours(0, 0, 0, 0)).toISOString();
        to = new Date(today.setHours(23, 59, 59, 999)).toISOString();
        break;
      case "week":
        const firstDayWeek = new Date(
          today.setDate(today.getDate() - today.getDay())
        );
        from = new Date(firstDayWeek.setHours(0, 0, 0, 0)).toISOString();
        to = new Date(today.setHours(23, 59, 59, 999)).toISOString();
        break;
      case "month":
        const firstDayMonth = new Date(
          today.getFullYear(),
          today.getMonth(),
          1
        );
        from = firstDayMonth.toISOString();
        to = new Date(
          today.getFullYear(),
          today.getMonth() + 1,
          0,
          23,
          59,
          59
        ).toISOString();
        break;
      case "year":
        const firstDayYear = new Date(today.getFullYear(), 0, 1);
        from = firstDayYear.toISOString();
        to = new Date(today.getFullYear(), 11, 31, 23, 59, 59).toISOString();
        break;
      case "custom":
        if (filters.customFrom)
          from = new Date(filters.customFrom).toISOString();
        if (filters.customTo) to = new Date(filters.customTo).toISOString();
        break;
      default:
        break;
    }

    if (from) url += `&from=${from}`;
    if (to) url += `&to=${to}`;

    axios
      .get(url)
      .then((res) => this.setState({ requests: res.data }))
      .catch((err) => console.error(err));
  };

  handleSave = () => {
    const { form, isEdit } = this.state;

    // Basic Validation
    if (!form.employeeId) {
      alert("Please select an employee.");
      return;
    }

    if (!form.date) {
      alert("Please select a valid date.");
      return;
    }

    if (!form.description || form.description.trim() === "") {
      alert("Please enter a description.");
      return;
    }

    const payload = {
      storeId: this.context.storeId,
      employeeId: form.employeeId,
      date: new Date(form.date).toISOString(),
      description: form.description.trim(),
      status: Number(form.status) || 0,
    };

    if (isEdit) {
      axios
        .put(`${process.env.REACT_APP_API}EmployeeRequests/${form.id}`, payload)
        .then(() => {
          this.applyFilters();
          this.handleCloseModal();
        })
        .catch((err) => alert("Failed to update request."));
    } else {
      axios
        .post(`${process.env.REACT_APP_API}EmployeeRequests`, payload)
        .then(() => {
          this.applyFilters();
          this.handleCloseModal();
        })
        .catch((err) => alert("Failed to add request."));
    }
  };

  handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this request?")) {
      axios
        .delete(`${process.env.REACT_APP_API}EmployeeRequests/${id}`)
        .then(() => this.applyFilters());
    }
  };

  handlePrint = () => {
    const { requests, employees } = this.state;

    // Build table HTML manually
    const tableHTML = `
    <table border="1" cellspacing="0" cellpadding="5" style="border-collapse: collapse; width: 100%;">
      <thead>
        <tr>
          <th>Employee</th>
          <th>Date</th>
          <th>Description</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        ${requests
          .map((r) => {
            const emp = employees.find((e) => e.id === r.employeeId);
            const employeeName = emp ? `${emp.firstName} ${emp.lastName}` : "";
            const date = r.date ? new Date(r.date).toLocaleDateString() : "";
            const status =
              r.status === 0
                ? "Pending"
                : r.status === 1
                ? "Approved"
                : "Rejected";
            return `
              <tr>
                <td>${employeeName}</td>
                <td>${date}</td>
                <td>${r.description || ""}</td>
                <td>${status}</td>
              </tr>
            `;
          })
          .join("")}
      </tbody>
    </table>
  `;

    const newWin = window.open("");
    newWin.document.write(`
    <html>
      <head>
        <title>Employee Requests</title>
        <style>
          table { border-collapse: collapse; width: 100%; }
          th, td { border: 1px solid black; padding: 5px; text-align: left; }
        </style>
      </head>
      <body>
        <h3>Employee Requests</h3>
        ${tableHTML}
      </body>
    </html>
  `);
    newWin.document.close();
    newWin.focus();
    newWin.print();
    newWin.close();
  };

  render() {
    const { requests, employees, showModal, form, filters } = this.state;

    return (
      <div>
        <h3>
          <b>Employee Requests</b>
        </h3>
        {/* Filters Row */}
        <Row className="mb-3 mt-3 align-items-center">
          <Col md={3} sm={6}>
            <Form.Group>
              <Form.Label>Employee</Form.Label>
              <Form.Control
                as="select"
                name="employeeId"
                value={filters.employeeId}
                onChange={this.handleFilterChange}
              >
                <option value="">-- All Employees --</option>
                {employees.map((emp) => (
                  <option key={emp.id} value={emp.id}>
                    {emp.firstName} {emp.lastName}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>

          <Col md={2} sm={6}>
            <Form.Group>
              <Form.Label>Status</Form.Label>
              <Form.Control
                as="select"
                name="status"
                value={filters.status}
                onChange={this.handleFilterChange}
              >
                <option value="">-- All --</option>
                <option value={0}>Pending</option>
                <option value={1}>Approved</option>
                <option value={2}>Rejected</option>
              </Form.Control>
            </Form.Group>
          </Col>

          <Col md={3} sm={6}>
            <Form.Group>
              <Form.Label>Date</Form.Label>
              <Form.Control
                as="select"
                name="dateFilter"
                value={filters.dateFilter}
                onChange={this.handleFilterChange}
              >
                <option value="today">Today</option>
                <option value="week">This Week</option>
                <option value="month">This Month</option>
                <option value="year">This Year</option>
                <option value="custom">Custom</option>
              </Form.Control>
            </Form.Group>
          </Col>

          {filters.dateFilter === "custom" && (
            <>
              <Col md={2} sm={6}>
                <Form.Group>
                  <Form.Label>From</Form.Label>
                  <Form.Control
                    type="date"
                    name="customFrom"
                    value={filters.customFrom}
                    onChange={this.handleFilterChange}
                  />
                </Form.Group>
              </Col>
              <Col md={2} sm={6}>
                <Form.Group>
                  <Form.Label>To</Form.Label>
                  <Form.Control
                    type="date"
                    name="customTo"
                    value={filters.customTo}
                    onChange={this.handleFilterChange}
                  />
                </Form.Group>
              </Col>
            </>
          )}
        </Row>
        {/* Actions */}
        <Button className="mb-2" onClick={() => this.handleShowModal()}>
          Add Request
        </Button>{" "}
        <Button className="mb-2" variant="secondary" onClick={this.handlePrint}>
          Print
        </Button>
        {/* Requests Table */}
        <Table striped bordered hover className="mt-3" id="requestTable">
          <thead>
            <tr>
              <th>Employee</th>
              <th>Date</th>
              <th>Description</th>
              <th>Status</th>
              <th className="no-print">Actions</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((r) => {
              const emp = employees.find((e) => e.id === r.employeeId);
              const employeeName = emp
                ? `${emp.firstName} ${emp.lastName}`
                : "";
              return (
                <tr key={r.id}>
                  <td>{employeeName}</td>
                  <td>{r.date ? new Date(r.date).toLocaleDateString() : ""}</td>
                  <td>{r.description}</td>
                  <td>
                    {r.status === 0
                      ? "Pending"
                      : r.status === 1
                      ? "Approved"
                      : "Rejected"}
                  </td>
                  <td className="no-print">
                    <Button
                      variant="warning"
                      size="sm"
                      onClick={() => this.handleShowModal(r)}
                    >
                      Edit
                    </Button>{" "}
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => this.handleDelete(r.id)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        {/* Add/Edit Modal */}
        <Modal show={showModal} onHide={this.handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              {form.id ? "Edit Request" : "Add Request"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group>
                <Form.Label>Employee</Form.Label>
                <Form.Control
                  as="select"
                  name="employeeId"
                  value={form.employeeId || ""}
                  onChange={this.handleChange}
                >
                  <option value="">-- Select Employee --</option>
                  {employees.map((emp) => (
                    <option key={emp.id} value={emp.id}>
                      {emp.firstName} {emp.lastName}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>

              <Form.Group>
                <Form.Label>Date</Form.Label>
                <Form.Control
                  type="date"
                  name="date"
                  value={form.date?.split("T")[0] || ""}
                  onChange={this.handleChange}
                />
              </Form.Group>

              <Form.Group>
                <Form.Label>Request Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={8}
                  name="description"
                  value={form.description || ""}
                  onChange={this.handleChange}
                />
              </Form.Group>

              <Form.Group>
                <Form.Label>Status</Form.Label>
                <Form.Control
                  as="select"
                  name="status"
                  value={form.status}
                  onChange={this.handleChange}
                >
                  <option value={0}>Pending</option>
                  <option value={1}>Approved</option>
                  <option value={2}>Rejected</option>
                </Form.Control>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseModal}>
              Close
            </Button>
            <Button variant="primary" onClick={this.handleSave}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
